import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { ChatSearchParams } from "../chat-room/chat-room";

@Injectable()
export class ChatSearchParamsProvider {
  private CHAT_SEARCH_PARAMS_KEY: string = "pv-chat-search-params";
  private _chatSearchParams: ChatSearchParams;

  constructor(public storage: Storage) {}

  initialParams(): ChatSearchParams {
    this._chatSearchParams = <ChatSearchParams>{
      favorite_rank: 0,
    };
    return this._chatSearchParams;
  }

  async get(): Promise<ChatSearchParams> {
    if (this._chatSearchParams) return this._chatSearchParams;
    this._chatSearchParams = await this.storage.get(this.CHAT_SEARCH_PARAMS_KEY);
    return this._chatSearchParams;
  }

  set(params: ChatSearchParams): Promise<any> {
    this._chatSearchParams = params;
    return this.storage.set(this.CHAT_SEARCH_PARAMS_KEY, params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/chat-search-params/chat-search-params.ts